import { SeasonTrades } from "../../schemas/Trade";
import { manager } from "../stringConstants";


export const zeevTrades: SeasonTrades[] = [
    {
        season: "2016/17",
        allTrades: [
            {
                otherTeam: manager.idan,
                sentAway: "John Wall",
                gotInReturn: "Clint Capela"
            },
            {
                otherTeam: manager.idan,
                sentAway: "Kyle Lowry",
                gotInReturn: "Klay Thompson"
            },
            {
                otherTeam: manager.idan,
                sentAway: "Gordon Hayward",
                gotInReturn: "Trevor Ariza"
            },
            {
                otherTeam: manager.itay,
                sentAway: "Ben Simmons",
                gotInReturn: "Kevin Love"
            },
            {
                otherTeam: manager.yevgeny,
                sentAway: "Rudy Gobert, Devin Booker and Klay Thompson",
                gotInReturn: "Kawhi Leonard, Julius Randle, Rajon Rondo and Marquese Chriss",
                amongBestTrades: true
            },
            {
                otherTeam: manager.kobe,
                sentAway: "DeAndre Jordan and Bismack Biyombo", 
                gotInReturn: "Serge Ibaka and Harrison Barnes",
                amongBestTrades: true
              },
            {
                otherTeam: manager.mati,
                sentAway: "Julius Randle",
                gotInReturn: "Steven Adams and Evan Fournier"
              },
              {
                otherTeam: manager.shiran,
                sentAway: "Trevor Ariza",
                gotInReturn: "Derrick Favors"
              },
              {
                otherTeam: manager.idan,
                sentAway: "Steven Adams",
                gotInReturn: "Klay Thompson"
              },
              {
                otherTeam: manager.shiran,
                sentAway: "Kawhi Leonard and Derrick Favors",
                gotInReturn: "Nikola Jokic and Trevor Ariza",
                amongBestTrades: true
              },
              {
                otherTeam: manager.mati,
                sentAway: "Jeff Teague and 4th round pick", 
                gotInReturn: "JJ Redick and 1st round pick",
                amongBestTrades: true
              },
            {
                otherTeam: manager.itay,
                sentAway: "Kevin Love",
                gotInReturn: "Kemba Walker"
            },
            {
                otherTeam: manager.ariel,
                sentAway: "Kemba Walker",
                gotInReturn: "CJ McCollum and top 3 protected 1st round pick in 2018/19 draft",
                amongBestTrades: true
            }
        ]
    },
    {
      season: "2017/18",
      allTrades: [
        {
          otherTeam: manager.shiran,
          sentAway: "Bradley Beal and TJ Warren",
          gotInReturn: "Clint Capela and Jonas Valanciunas",
          amongBestTrades: true
        },
        {
          otherTeam: manager.mati,
          sentAway: "Gary Harris", 
          gotInReturn: "Brook Lopez"
        },
        {
          otherTeam: manager.shiran,
          sentAway: "TJ Warren",
          gotInReturn: "Evan Fournier"
        }
        
      ]
    },
    {
      season: "2018/19",
      allTrades: [
        {
        otherTeam: manager.yevgeny,
        sentAway: "Shai Gilgeous-Alexander",
        gotInReturn: "Larry Nance Jr"
        },
        {
          otherTeam: manager.ilya,
          sentAway: "LaMarcus Aldridge",
          gotInReturn: "Jimmy Butler"
        },
        {
          otherTeam: manager.ilya,
          sentAway: "Marc Gasol",
          gotInReturn: "DeMar DeRozan" 
        },
        {
          otherTeam: manager.idan,
          sentAway: "Klay Thompson and Mitchell Robinson",
          gotInReturn: "Kawhi Leonard",
          amongWorstTrades: true
        }
        
      ]
    }
]